import { render, staticRenderFns } from "./ListGroups.vue?vue&type=template&id=1560c12e&"
import script from "./ListGroups.vue?vue&type=script&lang=js&"
export * from "./ListGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1560c12e')) {
      api.createRecord('1560c12e', component.options)
    } else {
      api.reload('1560c12e', component.options)
    }
    module.hot.accept("./ListGroups.vue?vue&type=template&id=1560c12e&", function () {
      api.rerender('1560c12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListGroups.vue"
export default component.exports